export default "__VITE_ASSET__3f3e6af3__"